/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type courses_EnrollChildRequest = {
    billing_type: courses_EnrollChildRequest.billing_type;
    child_id: string;
    end_date?: string;
    enrollment_type: courses_EnrollChildRequest.enrollment_type;
    start_date: string;
};
export namespace courses_EnrollChildRequest {
    export enum billing_type {
        PER_MONTH = 'per_month',
        PER_UNIT = 'per_unit',
        FREE = 'free',
    }
    export enum enrollment_type {
        RECURRING = 'recurring',
        ONE_OFF = 'one_off',
    }
}

